// extracted by mini-css-extract-plugin
export default {"root":"v0e7qCFh39P6b7Inbz5k","container":"tAetKd0CtFzIcpzhqq_x","title":"ZZ5g8H2bxA43sObW_Fe6","body":"Aepj6OewLIbTBBhP6lQi","footer":"BXn84Md8J76wMiQn0ODV"};